<template lang="pug">
div.wrap-item-parent-asset
  div(v-if="parentAsset").relative.pagent-asset-info.f.fm.rounded.overflow-hidden
    div.wrap-main-img.overflow-hidden.f.fh.mr20
      img(:src="parentAsset.mainImg").h-full.object-fit-cover
    div
      span.fz16.bold.mb10.line-clamp-2 {{parentAsset.name}}
      div.f.fm.mb10
        v-icon(size="20px").mr4 {{getIconByAssetType(parentAsset.type)}}
        span.fz14.mt1 {{getNameByAssetType(parentAsset.type)}}
      div.f.flex-wrap
        span(v-for="tag in parentAsset.tags"
          ).tag.fz12.px10.py6.rounded.mr8.mb8 {{tag}}
    div.btn-change.absolute.t10.r12.f.fm
      div(@click="showParentAssetSelector = true").f.fm.cursor-pointer.mr12
        v-icon(size="20").mr4 mdi-autorenew
        span.fz14 変更する
      div(@click="removeMainAsset").f.fm.cursor-pointer
        v-icon(size="20").mr4 mdi-close
        span.fz14 メインアセットから解除

  div(v-else)
    div.inline-block
      div(@click="showParentAssetSelector=true"
        ).btn-add.f.fm.px10.py8.rounded.cursor-pointer
        v-icon(size="20" dark).mr8 mdi-shape-plus
        span.fz14.pt1 メインアセットを選択する

  ModalWindow(:showModal="showParentAssetSelector"
    @closeModalWindow="showParentAssetSelector = false")
    ModuleParentAssetSelector(
      :childAsset="childAsset"
      @closeModalWindow="showParentAssetSelector = false"
      @setParentAsset="setParentAsset")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-parent-asset {
  .pagent-asset-info {
    border: $basic_border;
    .wrap-main-img {
      width: 60%;
      max-width: 200px;
      max-height: 200px;
      img {
        max-height: 200px;
      }
    }
    .tag {
      border: $basic_border;
    }
    .btn-change {
      color: $secondary_text_color;
    }
  }
  .btn-add {
    background: $active_color;
    span {
      color: $dark_primary_text_color;
    }
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import ModalWindow from '@/components/shared/ModalWindow'
import ModuleParentAssetSelector from '@/components/module/ModuleParentAssetSelector'

export default {
  components: {
    ModalWindow, ModuleParentAssetSelector
  },
  props: {
    parentAsset: {
      type: Object,
      default: null
    },
    childAsset: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  data () {
    return {
      showParentAssetSelector: false
    }
  },
  methods: {
    setParentAsset (asset) {
      this.$emit('setParentAsset', asset)
    },
    removeMainAsset () {
      this.$emit('setParentAsset', null)
    }
  }
}
</script>
